import { general } from './general'
import { misc } from './misc'
import { statistics } from './statistics'
import { coverage } from './coverage'
import { benefit } from './benefit'
import { uom } from './uom'
import { busCls } from './busCls'
import { Tariff } from './tariff'
import { stdRisk } from './stdRisk'
import { scheme } from './scheme'

export const actions = Object.assign(
  {},
  general,
  statistics,
  coverage,
  benefit,
  uom,
  busCls,
  Tariff,
  stdRisk,
  scheme,
  misc
)
